module.exports = __webpack_public_path__ + "static/media/img-04.b88df80e.png";